import React from 'react';

const StatesMarquee = () => {
  const states = "CA • FL • GA • IL • IN • KY • MD • ME • MI • NC • NM • NY • OH • OR • PA • SC • TX • VA • WI";
  
  return (
    <div className="bg-orange-600 text-white py-2 overflow-hidden">
      <div className="marquee-container">
        <div className="marquee-content">
          <span className="marquee-text text-sm font-semibold">{states}</span>
          <span className="marquee-text text-sm font-semibold">{states}</span>
          <span className="marquee-text text-sm font-semibold">{states}</span>
          <span className="marquee-text text-sm font-semibold">{states}</span>
        </div>
      </div>
    </div>
  );
};

export default StatesMarquee;
